// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58be70f6","453":"d3bf6972","455":"03544837","977":"b6c0841b"}[chunkId] + ".chunk.js";
};